import React, { Component } from 'react';
import { Col, Modal } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { api } from '../../components/api/api';
import { Alert, AlertErro } from '../../util/Alertas';
import { FormataDataBrToEng } from '../../util/FormatacaoUtil';


class ModalEditaDataPagamento extends Component {
    constructor(props) {
        super(props);
        this.state = this.initialState
        this.Open = (reciboId, dataPgt = '') => this.setState({
            show: true,
            id: reciboId,
            data: dataPgt.split('T')[0]
        })
    }

    initialState = {
        show: false,
        id: 0,
        data: ''
    }

    handleClose = () => {
        this.setState(this.initialState)
        this.props.hadleReloadPage && this.props.hadleReloadPage()
    };

    handleSubmit = e => {
        const { id, data } = this.state;

        const formData = new FormData();
        formData.append("data", FormataDataBrToEng(data));

        api.post(`api/Recibo/GerarRecibo/${id}`, formData, res => {
            Alert('Data atualizada com sucesso!');
            this.handleClose();
        }, err => {
            console.clear();
            console.log(err);
            AlertErro(err, 'Houve um erro ao salvar os dados');
        })
    }

    render() {
        const { show, data, id } = this.state;

        return (
            <Modal show={show}>
                <Modal.Header>
                    <h2>Alterar Data Pagamento</h2>
                </Modal.Header>
                <Modal.Body>
                    <label>Informe a data pagamento</label>
                    <input type="date" className='form-control' value={data} onChange={e => this.setState({ data: e.target.value })} />
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-danger' onClick={this.handleClose}>Cancelar</button>
                    <button onClick={this.handleSubmit} disabled={!data || id === 0} className='btn btn-primary' type='submit'>Atualizar</button>
                </Modal.Footer>
            </Modal >
        );
    }
}

export default ModalEditaDataPagamento;